module.exports = __webpack_public_path__ + "static/index/img/404.56070013.jpg";